import PersonOffOutlinedIcon from '@mui/icons-material/PersonOffOutlined'
import { Alert } from '@mui/material'

import {
  COLOR_DRIVER_CANCELLATIONS,
  DRIVER_CANCELLATIONS_INFO,
} from 'components/reports/Metrics/constants/ExceptionMetrics'
import { useGetExceptionMetricsDriverCancellationsQuery } from 'generated/graphql'

import { MetricCard } from '../components'
import { useExceptionMetricsQueryInput } from './useExceptionMetricsQueryInput'

export const DriverCancellationsMetricCard = () => {
  const { hasValidRange, input } = useExceptionMetricsQueryInput()

  const { data, previousData, loading, error } = useGetExceptionMetricsDriverCancellationsQuery({
    variables: { input },
    skip: !hasValidRange,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-and-network',
  })

  const series =
    data?.exceptionMetricsDriverCancellations ?? previousData?.exceptionMetricsDriverCancellations

  if (error) {
    return (
      <Alert severity='error'>Failed to load driver cancellations metric. Please try again.</Alert>
    )
  }

  return (
    <MetricCard
      title='Driver cancellations post-allocation'
      countCaption='Jobs with cancellations'
      tooltipLabel='Cancelled'
      color={COLOR_DRIVER_CANCELLATIONS}
      icon={<PersonOffOutlinedIcon fontSize='small' />}
      info={DRIVER_CANCELLATIONS_INFO}
      series={series}
      loading={loading && !series}
    />
  )
}
